import { render, staticRenderFns } from "./UiSeparator.vue?vue&type=template&id=5cea0a75&"
import script from "./UiSeparator.vue?vue&type=script&lang=js&"
export * from "./UiSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports